// @flow

import * as React from 'react';
import { connect } from 'react-redux';

import { localize } from '@ta/common.i18n';

import type { ContentProps, InternalProps } from './base';
import { DefaultProps, defaultConnect } from './base';
import ReportIAPPanel from '../ReportIAPPanel';
import { ContentType } from '../submit/SubmitIapVote';

type Props = {
  ...ContentProps,
  ...InternalProps,
};

const ReportLocationTopicPostPanel = (props: Props) => (
  <ReportIAPPanel
    csrfToken={props.csrfToken}
    userId={props.userId}
    // $FlowFixMe contentId is fine, I'm not sure what you're so mad about.
    contentId={props.contentId}
    contentType={ContentType.LOCATION_POSTING}
    onError={props.onError}
    onComplete={props.onComplete}
    repostInfo={props.repostInfo}
  >
    {panel => (
      <React.Fragment>
        <div>{localize('qa_iap_label')}</div>
        {panel.createDefaultReasonWithRequiredComment('INAPPROPRIATE')}
      </React.Fragment>
    )}
  </ReportIAPPanel>
);
ReportLocationTopicPostPanel.defaultProps = DefaultProps;

// $FlowFixMe92
export default connect(state => defaultConnect(state))(ReportLocationTopicPostPanel);
